/* eslint-disable import/prefer-default-export */

import * as req from 'api/actions';
import * as c from './constant';

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );